import en from 'vee-validate/dist/locale/en.json'

export default {
    validation: en.messages,
    Titles: {
        recentAssessments: 'Recently completed assessment',
        filters: 'Filter',
        ambientMode: 'Demonstration',
    },
    Alerts: {
        deletePicture: 'Will not be able to recover this photo',
        noAddress: 'Profile without address',
        yourEmail: 'Your email',
        unsavedChanges:
            'You have unsaved changes. Would you like to save them before leaving?',
        removeProfile: 'You are removing a profile from {location}',
        inactiveAttendance: 'Inactive students cannot make attendance',
        askChangeDate: 'Are you sure you want to change the date?',
        deactivateClass:
            'This class will no longer appear on the occupation map',
        askNewAttendance: 'Make another attendance?',
        attendanceLost: 'Unsaved attendances will be lost!',
        noImage: 'The file must be an image',
        copyToClipboard: 'Copied to clipboard',
        saveSuccess: 'Successfully saved',
        changedSuccess: 'Successfully changed',
        createdSuccess: 'Successfully created',
        deletedSuccess: 'Successfully deleted',
        removedSuccess: 'Successfully removed',
        sendSuccess: 'Successfully sent',
        sure: 'Are you sure?',
        irreversible: 'This action is irreversible!',
        cancel: 'Cancel',
        no: 'No',
        yes: 'Yes',
        deleteAction: 'Confirm',
        userError: 'Something went wrong, try again later.',
        usersLimit:
            'You have reached the registration limit in your plan, contact your Customer Success',
        noProfileSelected: 'A profile must be selected',
        cantDeleteYourself: 'You cannot disable/delete your own profile',
        cantInactivateLoggedLocation:
            "It's not possible to inactivate the same location you are logged in",
        askDeactivate: 'Do you really want to inactivate this registry?',
        warningDeactivate:
            'He/she will no longer be able to access the platform',
        askDeactivateLocation:
            'Do you really want to inactivate this location?',
        warningDeactivateLocation:
            'Everyone registered in this unit will lose access!',
        sessionExpired: 'Your section has expired, please sign in again.',
        cantChangeProfile:
            'It is not possible to change a profile on a disabled user.',
        deleteAlert: 'To delete that, click on the Delete button.',
        selectUsersToDelete: 'Select the records you want to delete',
        saveFirst: 'To proceed, you must save the calendar.',
        selectAll: 'Select all items before adding',
        registerLesson: 'Register at least one class before saving.',
        accessDenied: 'You do not have permission for this functionality.',
        notFound: 'Page not found',
        serverError: 'A server error has occurred, please try again later',
        responsibleAlreadyIncluded:
            'This responsible is already included in this student',
        studentAlreadyIncluded:
            'This student is already included in this responsible',
        maxLevelStudents: 'We recommend  {maxStudents} students for this level',
        selectLevelFirst: 'Select a level before electing students',
        diferentLevel: 'This student is on a different level than the class.',
        studentAlreadyIncludedInClass:
            'This student is already included in this class.',
        changingLevelClass:
            'Are you sure you want to change the level of this class?',
        removeStudents: 'All old students will be removed',
        checkAllStudents:
            'All students must be marked with presence / absence before saving',
        onlyActiveUsers: 'Only active users can be added',
        noQuestions:
            'It is not possible to make an evaluation model without questions',
        activeAssessment:
            'Once this assessment is effective, you will no longer be able to edit it',
        selectItemsFirst: 'Select the items to be deleted',
        selectStudents: 'Select students to take the assessment',
        selectStudentsToAttendance: 'Select students to take the attendance',
        studentWithoutAnswer:
            'Before continuing, enter the result of all students',
        pauseAlert: "You will pause this student's assessment",
        pauseDescription: 'But you can continue evaluating it later',
        studentsWithoutComments: 'Students marked "Yes" must have a comment',
        studentsNoCheck:
            'Before proceeding, mark students who have comments or not',
        deleteFolder:
            'You will delete this folder and all of its contents. This action is irreversible.',
        selectFile: 'Select the file to save',
        invalidDateValue: 'Invalid time range',
        maxSize: 'You can only save files up to 10MB',
        cantDownload: 'You do not have permission to download this file',
        changePasswordSuccess: 'Password changed successfully',
        cantEditAssessment: 'Finished Assessment cannot be edited,',
        goToNewAssessments:
            'Use the assessments through the new panel, just access "New panel" in the menu and click on "Access panel".',
        wantDoAssessment: 'Want to do an assessment?',
    },
    Menu: {
        profile: 'My profile',
        attendance: 'Attendance',
        occupancyMap: 'Occupation Map',
        partners: 'Partners',
        newPartner: 'New partner',
        editPartner: 'Edit partner',
        integration: 'Integration',
        newIntegration: 'New integration',
        partnerManagement: 'Integration management',
        newPartnerToken: 'New Partner Token',
        students: 'Students',
        newStudent: 'New Student',
        editStudent: 'Edit Student',
        responsible: 'Responsibles',
        classLesson: 'Lesson',
        newResponsible: 'New responsible',
        editResponsible: 'Edit responsible',
        classgrade: 'Classes',
        newClassgrade: 'Create new class',
        editClassGrade: 'Edit class',
        teachingAreas: 'Pools',
        newTeachingAreas: 'Create new pool',
        editTeachingAreas: 'Edit pool',
        team: 'Team',
        newTeam: 'Create new team member',
        editTeam: 'Edit a team member',
        assessmentStudents: 'Assessments',
        assessmentStudentsNewModule: 'New panel',
        assessmentResult: 'Assessment result',
        assessmentApplication: 'Applying assessment',
        showStores: 'My Stores',
        SubItems: {
            pedagogic: 'Pedagogic',
            configurations: 'Configurations',
        },
        goals: 'Goals',
        newGoal: 'New goal',
        editGoal: 'Edit goal',
        contents: 'Contents',
        newContent: 'New content',
        editContent: 'Edit content',
        scheduleMap: 'Goals Calendar',
        newScheduleMap: 'New goals calendar',
        editScheduleMap: 'Edit goals calendar',
        newLesson: 'New lesson',
        editLesson: 'Edit lesson',
        assessmentModel: 'Assessments Models',
        newAssessmentModel: 'New assessment model',
        editAssessmentModel: 'Edit assessment model',
        newAssessmentQuestion: 'New question',
        editAssessmentQuestion: 'Edit question',
        plans: 'Plans',
        newPlans: 'Create new plan',
        editPlan: 'Edit plan',
        clients: 'Accrediteds',
        newClient: 'New accrediteds',
        editClient: 'Edit accrediteds',
        locations: 'Locations',
        newLocation: 'New location',
        editLocation: 'Edit location',
        locationBuyers: 'Shopkeeper',
        newLocationBuyer: 'New shopkeeper',
        editLocationBuyer: 'Edit shopkeeper',
        staff: 'Staff',
        newStaff: 'New staff',
        editStaff: 'Edit staff',
        uploads: 'File manager',
        downloads: 'Downloads',
        courses: 'Courses',
        certification: 'Certification',
        faq: 'FAQ',
    },
    Errors: {
        notImage: 'No image',
        invalidLogin: 'Invalid e-mail or password',
        minValue: 'Enter a value greater than 0',
        accessDenied: 'User does not have a profile with access to the tool',
        selectLocation: 'Select a location before proceeding',
        emailNotFound: 'E-mail not found',
        invalidDate: 'Please enter a valid date',
        requiredField: 'This field is required',
        emailFormat: 'This field must have the format ***@***.***',
        invalidCep: 'Please enter a valid zip code',
        dateFromToday: 'It cant be less than today',
        error_400: {
            title: 'Requisition error',
            description: '',
        },
        error_401: {
            title: 'Not authorized',
            description: '',
        },
        error_403: {
            title: 'Forbidden access',
            description: '',
        },
        error_404: {
            title: 'Page not found',
            description: 'The requested page could not be found',
        },
        error_500: {
            title: 'Server error',
            description: 'Try again later',
        },
        invalidHours: 'Enter a valid range of hours',
        invalidHour: 'Enter a valid hour',
        typePositiveNumber: 'The number of students must be greater than 0',
        inactiveUser: 'Select an active option to continue.',
        invalidCPF: 'The CPF is incomplete; it must have 11 numbers',
        invalidCNPJ: 'The CNPJ is incomplete; it must have 14 numbers',
        specialCharacter: 'The use of special characters is not allowed',
        passwordLengthRule:
            'The Password must be at least 8 and at max 100 characters long.',
    },
    Language: {
        portuguese: 'Portuguese',
        spanish: 'Spanish',
        english: 'English',
    },
    Login: {
        welcome: 'Welcome',
        presentationText:
            'Manage your units and customers in an easy, visual and intuitive way.',
        quote: 'Education through swimming.',
        forgotPassword: 'Forgot password?',
        insertEmail: 'Enter your email to reset your password:',
        chooseLocation: 'Choose a location',
        locationText: 'Before logging in, choose the unit from the list below.',
        insertPassword: 'New password',
        successNewPassword: 'Password changed successfully.',
        resetPasswordInform:
            'We are checking if the email {userEmail} is registered on our platform, if it is, it will be sending an email with instructions and the link for you to change your password.',
    },
    Fields: {
        names: {
            email: 'E-mail',
            password: 'Password',
        },
        labels: {
            replace: 'Replacement',
            email: 'E-mail',
            password: 'Password',
            points: 'Points',
            users: 'Users',
            students: 'Students',
            inactive: 'INACTIVE',
            yes: 'Yes',
            no: 'No',
            achievement: 'achievement',
            uploadFile: 'Drag a file here or click to select a file',
            characters: 'characters',
            items: 'Itens',
            currentPassword: 'Current password',
            newPassword: 'New password',
            confirmPassword: 'Confirm new password',
        },
        select: {
            searchStudent: "Search by student's name",
            selectLabel: 'Select',
            deselectLabel: 'Remove',
            noResult: 'No results',
            noOptions: 'Empty list',
            selectOption: 'Select an option',
            searchOption: 'Type your search here',
            locationPlaceholder: 'Choose a location',
            selected: 'Selected',
            other: 'Other',
            male: 'Male',
            female: 'Female',
            searchHere: 'Your search will appear here',
            selectAll: 'Select all',
            options: {
                Permission: [
                    {
                        name: 'Public',
                        value: 0,
                    },
                    {
                        name: 'Private',
                        value: 1,
                    },
                ],
                Situation: [
                    {
                        name: 'Active',
                        value: true,
                    },
                    {
                        name: 'Inactive',
                        value: false,
                    },
                ],
                UnitTypes: [
                    {
                        name: 'Academy',
                        value: 1,
                    },
                    {
                        name: 'School',
                        value: 2,
                    },
                    {
                        name: 'Club',
                        value: 3,
                    },
                ],
                Entity: [
                    {
                        name: 'Individual / Individual',
                        value: 1,
                    },
                    {
                        name: 'Corporate / PJ',
                        value: 2,
                    },
                    {
                        name: 'International',
                        value: 3,
                    },
                ],
                QuestionItemType: [
                    {
                        name: 'Performs',
                        value: 0,
                    },
                    {
                        name: 'Value',
                        value: 1,
                    },
                    {
                        name: 'Time',
                        value: 2,
                    },
                ],
            },
        },
        placeholder: {
            newPassword: 'New password',
            typeQuery: 'Type your search',
        },
        values: {
            copyOf: 'Copy of',
        },
        filters: {
            filterText: 'Filtros',
        },
    },
    Buttons: {
        choosePhoto: 'Choose photo',
        cut: 'Cut and save',
        reset: 'Reset',
        changePhoto: 'Change photo',
        removePhoto: 'Remove photo',
        myProfile: 'My profile',
        changeDate: 'Change date',
        doAttendance: 'Do attendance',
        copyToken: 'Copy token',
        resendEmail: 'Reset password',
        send: 'Send',
        back: 'Back',
        logIn: 'Enter',
        continue: 'Continue',
        save: 'Save',
        exit: 'Exit',
        changeLocation: 'Change location',
        pagination: 'See more',
        new: 'New',
        doAssessment: 'Do assessment',
        continueAssessment: 'Continue assessment',
        addLessons: 'Add lessons',
        update: 'Update',
        newResponsible: 'Register new responsible',
        newStudent: 'Register student',
        newLocation: 'Register new location',
        today: 'Today',
        saveAttendance: 'Save attendance',
        inactive: 'Inactive',
        shopkeeper: 'Shopkeeper',
        newQuestion: 'New Question',
        addArchive: 'Add file',
        filter: 'Filter',
        cleanFilter: 'Clean filters',
        changeImage: 'Change/remove image',
        accessEcommerce: 'Access Ecommerce',
        changePassword: 'Change password',
        add: 'Add',
        edit: 'Edit',
        clone: 'Clone',
        delete: 'Delete',
        pause: 'Pause',
    },
    Table: {
        noData: 'No data',
        noImage: 'No image',
        noEmail: 'No email',
        titles: {
            studentsLimit: 'Students limit',
            employeesLimit: 'Staff limite',
            partner: 'Partner',
            private: 'Private',
            location: 'Location',
            releaseDate: 'Release date',
            name: 'Name',
            nameClassGrade: 'Class Name',
            buyer: 'Buyer',
            evaluator: 'Evaluator',
            asssessmentComments: 'Comments?',
            email: 'E-mail',
            profile: 'Profile',
            generationDate: 'Generation date',
            phone: 'Phone',
            status: 'Active/Inactive',
            actions: 'Actions',
            dimensions: 'Dimensions',
            depth: 'Depth',
            squareMeter: 'Square meter',
            planName: 'Plan name',
            description: 'Description',
            modules: 'Modules',
            allowed: 'Allowed',
            startDate: 'Start',
            startTime: 'Time',
            teacher: 'Teacher',
            dayOfWeek: 'Day of week',
            vacances: 'Vacances',
            endDate: 'Final',
            levels: 'Levels',
            level: 'Level',
            active: 'Active',
            objective: 'Objective',
            contents: 'Contents',
            textPTBR: 'Portuguese',
            textES: 'Spanish',
            textEN: 'English',
            companyName: 'Company name',
            tradingName: 'Trading name',
            document: 'Document',
            registration: 'Registration',
            customerSuccess: 'Customer Success',
            cityState: 'City - State',
            plan: 'Plan',
            type: 'Type',
            age: 'Age',
            presence: 'Presence',
            pedagogicType: 'Pedagogic Type',
            quantityQuestion: 'Questions',
            assessmentAccomplishedScore: 'Score',
            current: 'Current',
            assessmentStatus: 'Status',
            questions: 'Questions',
            items: 'Items',
            points: 'Score',
            order: 'Order',
            published: 'Published',
            execute: 'Performs',
            hitRate: 'Hit rate',
            comments: 'Comments',
        },
        noClassName: '[No class name]',
        noClassTeacher: '[No class teacher]',
        noEndDate: 'Without end date',
        noComments: 'Student without comments',
        ready: 'Ready',
        inProgress: 'In progress',
        to: 'to',
        inactiveProfile: 'This profile is inactive',
        months: 'month(s)',
        age: 'year(s)',
    },
    Profiles: [
        {
            text: 'Owner',
            textShow: 'Owner',
            value: '1',
        },
        {
            text: 'Coordinator',
            textShow: 'Coordinator',
            value: '2',
        },
        {
            text: 'Teacher',
            textShow: 'Teacher',
            value: '3',
        },
        {
            text: 'Student',
            textShow: 'Student',
            value: '4',
        },
        {
            text: 'Customer Success',
            textShow: 'CustomerSuccess',
            value: '5',
        },
        {
            text: 'Manager',
            textShow: 'Manager',
            value: '6',
        },
        {
            text: 'Administrator',
            textShow: 'Admin',
            value: '7',
        },
        {
            text: 'Secretary',
            textShow: 'Secretary',
            value: '8',
        },
        {
            text: 'Responsible',
            textShow: 'Responsible',
            value: '9',
        },
        {
            text: 'Support',
            textShow: 'Support',
            value: '10',
        },
        {
            text: 'Pedagogic',
            textShow: 'Educator',
            value: '11',
        },
        {
            text: 'Sales',
            textShow: 'Seller',
            value: '12',
        },
        {
            text: 'Marketing',
            textShow: 'Marketing',
            value: '13',
        },
        {
            text: 'Developer',
            textShow: 'Developer',
            value: '14',
        },
    ],
    Status: [
        {
            name: 'Active',
            value: true,
        },
        {
            name: 'Inactive',
            value: false,
        },
    ],
    YesNoOptions: [
        {
            name: 'Yes',
            value: true,
        },
        {
            name: 'No',
            value: false,
        },
    ],
    Inputs: {
        selectAttendanceDate: 'Select attendance date',
        attendanceDate: 'Attendance date',
        releaseDate: 'Release date',
        generationDate: 'Generation date',
        name: 'Name',
        nameClassGrade: 'Class Name',
        firstName: 'First name',
        dateTime: 'Select date and time',
        lastName: 'Last name',
        gender: 'Gender',
        partnerSelect: 'Select a partner',
        birthday: 'Date of birth',
        cpf: 'ID',
        email: 'E-mail',
        studentEmail: 'Student e-mail',
        telephone: 'Contact number',
        postalCode: 'Zip code',
        address: 'Address',
        addressNumber: 'Number',
        addressComplement: 'Complement',
        neighborhood: 'Neighborhood',
        country: 'Country',
        state: 'State',
        city: 'City',
        weekdaySelect: 'Select week day',
        studentSelect: 'Select student',
        levelSelect: 'Select a level',
        teacherSelect: 'Select a teacher',
        poolSelect: 'Select a pool',
        unitSelect: 'Select an unit',
        unitSelectSimple: 'Select an unit',
        unitTypeSelect: 'Select the unit type',
        entitySelect: 'Select the entity type',
        planSelect: 'Select a plan',
        plansSelect: 'Select plans',
        profilesSelect: 'Select profiles',
        customerSuccessSelect: 'Select a customer success',
        situationSelect: 'Select the status',
        pedagogicTypeSelect: 'Select the pedagogic type',
        calendarSelect: 'Select a date',
        calendarTypeSelect: 'Select the calendar type',
        assessmentQuestionItemTypeSelect: 'Select the question type',
        clientSelect: 'Select the customer',
        monthlyFee: 'Monthly fee',
        registration: 'Registration',
        platformAccessToggle: 'Can access this system?',
        poolName: 'Pool name',
        poolDescription: 'Pool description',
        poolLength: 'Length',
        poolWidth: 'Width',
        poolDepth: 'Depth',
        numberOfStudents: 'Number of students',
        numberOfStudentsInClass: 'Number of students in class',
        classStartTime: 'Start time',
        classEndTime: 'End time',
        weekdays: 'Class day',
        tradingName: 'Trading name',
        companyName: 'Corporate name',
        document: 'Document',
        stateRegistration: 'State registry',
        municipalRegistration: 'Municipal registry',
        personalWebsite: 'Website',
        facebook: 'Facebook',
        instagram: 'Instagram',
        calendarDescription: 'Calendar description',
        planLimitStudentsToggle: 'Unlimited?',
        planLimitStudentsInput: 'Students limit',
        planLimitStaffToggle: 'Unlimited?',
        planLimitStaffInput: 'Staff limit',
        planDescription: 'Plan description',
        planColor: 'Plan color',
        portugueseLanguage: 'Portuguese',
        englishLanguage: 'English',
        spanishLanguage: 'Spanish',
        toggleCurrentAssessment: 'Current',
        assessmentQuestion: 'Type the question of this evaluation',
        assessmentQuestionItem: 'Type the item of this question',
        assessmentQuestionItemGrade: "This item's points",
        accreditedName: 'Accredited name',
        availableCharacters: 'Available characters',
        initialDate: 'Initial date',
        endDate: 'End date',
        rangeDate: 'Select a period',
        statusSelect: 'Select a status',
        goalsSelect: 'Select an objective',
        contentsSelect: 'Select contents',
        staffSelect: 'Select a staff',
        hasResponsibleSelect: 'Student with responsible',
        hasStudentSelect: 'Responsible with student',
        hasEmailSelect: 'With/Without email',
        plataformAccessSelect: 'Platform access',
        filterLevel: 'Level(s)',
        filterPool: 'Pool(s)',
        filterTeacher: 'Teacher(s)',
        selectTeachers: 'All teachers',
        selectPools: 'All pools',
        selectLevels: 'All levels',
        buyerSelect: 'Buyer',
        current: 'Current',
        points: 'Points:',
        questionItem: 'Type the item of this question',
        itemType: 'Type',
        itemPoints: 'Points',
        order: 'Order',
        assessmentComments: 'Student Comments',
        fileName: 'File name',
        description: 'Description',
        permissionSelect: 'Public/Private',
        languageSelect: 'Select language',
    },
    States: {
        Brazil: [
            {
                abbv: 'AC',
                full: 'Acre',
            },
            {
                abbv: 'AL',
                full: 'Alagoas',
            },
            {
                abbv: 'AP',
                full: 'Amapá',
            },
            {
                abbv: 'AM',
                full: 'Amazonas',
            },
            {
                abbv: 'BA',
                full: 'Bahia',
            },
            {
                abbv: 'CE',
                full: 'Ceará',
            },
            {
                abbv: 'DF',
                full: 'Distrito Federal',
            },
            {
                abbv: 'ES',
                full: 'Espírito Santo',
            },
            {
                abbv: 'GO',
                full: 'Goiás',
            },
            {
                abbv: 'MA',
                full: 'Maranhão',
            },
            {
                abbv: 'MT',
                full: 'Mato Grosso',
            },
            {
                abbv: 'MS',
                full: 'Mato Grosso do Sul',
            },
            {
                abbv: 'MG',
                full: 'Minas Gerais',
            },
            {
                abbv: 'PA',
                full: 'Pará',
            },
            {
                abbv: 'PB',
                full: 'Paraíba',
            },
            {
                abbv: 'PR',
                full: 'Paraná',
            },
            {
                abbv: 'PE',
                full: 'Pernambuco',
            },
            {
                abbv: 'PI',
                full: 'Piauí',
            },
            {
                abbv: 'RJ',
                full: 'Rio de Janeiro',
            },
            {
                abbv: 'RN',
                full: 'Rio Grande do Norte',
            },
            {
                abbv: 'RS',
                full: 'Rio Grande do Sul',
            },
            {
                abbv: 'RO',
                full: 'Rondônia',
            },
            {
                abbv: 'RR',
                full: 'Roraima',
            },
            {
                abbv: 'SC',
                full: 'Santa Catarina',
            },
            {
                abbv: 'SP',
                full: 'São Paulo',
            },
            {
                abbv: 'SE',
                full: 'Sergipe',
            },
            {
                abbv: 'TO',
                full: 'Tocantins',
            },
        ],
    },
    DaysOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
    ],
    Levels: [
        {
            abbreviaton: 'BB1',
            color: 'avtWhite',
            name: 'Bebê 1',
            id: 1,
        },
        {
            abbreviaton: 'BB2',
            color: 'avtWhite',
            name: 'Bebê 2',
            id: 2,
        },
        {
            abbreviaton: 'BB3',
            id: 3,
            color: 'avtYellow',
            name: 'Bebê 3',
        },
        {
            abbreviaton: 'ADAP',
            id: 4,
            color: 'avtOrange',
            name: 'Adaptação Infantil',
        },
        {
            abbreviaton: 'INIC',
            id: 5,
            color: 'avtRed',
            name: 'Iniciação Infantil',
        },
        {
            abbreviaton: 'AP1',
            id: 6,
            color: 'avtGreen',
            name: 'Aperfeiçoamento 1',
        },
        {
            abbreviaton: 'AP2',
            id: 7,
            color: 'avtLightBlue',
            name: 'Aperfeiçoamento 2',
        },
        {
            abbreviaton: 'AP3',
            id: 8,
            color: 'avtHeavyBlue',
            name: 'Aperfeiçoamento 3',
        },
        {
            abbreviaton: 'EQ',
            id: 9,
            color: 'avtYellow',
            name: 'Equipe',
        },
        {
            abbreviaton: 'FS',
            id: 10,
            color: 'avtBlack',
            name: 'Fast swim',
        },
        {
            abbreviaton: 'COND1',
            id: 11,
            color: 'avtBlack',
            name: 'Condicionamento 1',
        },
        {
            abbreviaton: 'COND2',
            id: 12,
            color: 'avtBlack',
            name: 'Condicionamento 2',
        },
        {
            abbreviaton: 'ADAP_AD',
            id: 13,
            color: 'avtBlack',
            name: 'Adaptação Adulto',
        },
        {
            abbreviaton: 'INIC_AD',
            id: 14,
            color: 'avtBlack',
            name: 'Iniciação Adulto',
        },
    ],
    Subtitles: {
        periods: 'View of Lessons grouped by periods',
        classes: 'Lessons',
        profiles: 'Profiles',
        responsibles: 'Responsibles',
        units: 'Units',
        students: 'Students',
        registrationData: 'Registration data',
        contractualData: 'Contractual data',
        socialNetwork: 'Site and social networks',
        locationData: 'Location data',
        locationStore: 'Stores list',
        aboutLesson: 'About lesson',
        aboutStudents: 'About students',
        questions: 'Questions',
        questionItems: 'Question items',
        aboutAssessment: 'About assessment',
        assessmentPerformance: 'Overall assessment performance',
        assessmentComentary: 'Assessment comments',
        assessmentDetails: 'Assessment details',
    },
    Descriptions: {
        performanceDescription:
            'summary of student performance in this assessment, below are listed the questions that were applied',
        assessmentDetailsDescription:
            'details of the questions applied in this evaluation, the analysis below is made individually for each question',
    },
    OccupancyMap: {
        noEvents: 'No events',
        classes: 'Class(es)',
        vacancys: 'Total Vacancies',
        enrollment: 'Vacantes ocupadas',
        occupancy: 'Ocupation',
        seeLesson: 'See lesson',
        seeClass: 'See class',
        teacher: 'Teacher',
    },
    AssessmentItemType: [
        {
            name: 'Performs',
            value: 0,
        },
        {
            name: 'Value',
            value: 1,
        },
        {
            name: 'Time',
            value: 2,
        },
    ],
    AssessmentStatus: ['IN PROGRESS', 'FINISHED', 'UNPUBLISHED', 'PUBLISHED'],
    ScoreStatus: [
        "couldn't performed",
        'under development',
        'regular',
        'good',
        'great',
        'excellent',
    ],
    AssessmentApplication: {
        comments: 'Enter comments for students',
        commentsButton: 'Close comments',
        finish: 'Finish assessment',
    },
    Rightpanel: {
        info: 'Informations',
        addFile: 'Add file',
        editFile: 'Edit file',
        seeFile: 'See file',
        download: 'Download',
        startDate: 'Start',
        endDate: 'End',
        plans: 'Plans',
        profiles: 'Profiles',
        extension: 'Extension',
        picture: 'Upload your photo',
        dragFile: 'Drag a file here',
        selectFile: ['Or if you prefer ...', 'Select a file'],
        share: 'Share',
    },
    EmptyState: {
        notFound: 'We found nothing here',
        createNewAssessment: 'doing an assessment in a student',
        createNewRegistry: 'But you can create a new record',
        clickingHere: 'clicking here',
    },
    Filter: {
        title: 'Filter',
        label: 'Active filters',
        Status: 'Status',
        Plans: 'Plans',
        Profiles: 'Profile',
        StartDate: 'Start',
        StartTime: 'Start time',
        EndDate: 'End date',
        EndTime: 'End time',
        TeacherPublicIds: 'Teachers',
        StudentPublicIds: 'Students',
        NumberOfStudents: 'Number of students',
        MinNumberOfStudents: 'Min. Number of students',
        MaxNumberOfStudents: 'Max. Number of students',
        LevelPublicIds: 'Levels',
        ClassTeachingAreaPublicIds: 'Pools',
        DayOfTheWeeks: 'Day of the week',
        HasResponsible: 'Student with responsible',
        HasEmail: 'Has platform access',
        HasDependant: 'Responsible with student',
        Name: 'Name',
        Document: 'Document',
        CompanyName: 'Company name',
        TradingName: 'Trading name',
        Registration: 'Registration',
        Email: 'E-mail',
        Telephone: 'Telephone',
        AssessmentStatus: [
            {
                name: 'In progress',
                value: false,
            },
            {
                name: 'Finished',
                value: true,
            },
            {
                name: 'Published',
                value: false,
            },
            {
                name: 'Unpublished',
                value: false,
            },
        ],
    },
}
